import React, { useEffect, useState } from 'react';
import TestimonialCard from '../TestimonialCard/TestimonialCard';


const TestimonialsMain = () => {
    const [testimonials, setTestimonials] = useState([])
    useEffect(() => {
        fetch('https://assignment-11-samiun.herokuapp.com/review')
        .then(res => res.json())
        .then(data => setTestimonials(data))
    }, [])
    return (
        <div className="mt-5 mb-5 p-5" style={{background: 'whitesmoke'}}>
            <h3 className="text-center text-color mb-5"><b>Testimonials</b></h3>
            <div className="row d-flex justify-content-center">
                {
                    testimonials.map(testimonial => <TestimonialCard testimonial={testimonial}/>)
                }
            </div>
        </div>
    );
};

export default TestimonialsMain;